import {
  getPendingReminders,
  markReminderNotified,
} from "./reminderStorage";

let timerId = null;
const timeouts = new Map();

export async function requestNotificationPermission() {
  if (!("Notification" in window)) return false;
  if (Notification.permission === "granted") return true;
  if (Notification.permission === "denied") return false;
  const result = await Notification.requestPermission();
  return result === "granted";
}

function speakReminder(text) {
  if (!window.speechSynthesis || !text) return;
  window.speechSynthesis.cancel();
  const utter = new SpeechSynthesisUtterance(text);
  utter.lang = "zh-CN";
  utter.rate = 0.95;
  window.speechSynthesis.speak(utter);
}

function fireNotification(reminder) {
  const title = "备忘提醒";
  const body = reminder.content || reminder.source_text || "您有一条提醒";

  speakReminder(`提醒时间到了，${body}`);

  window.dispatchEvent(
    new CustomEvent("voiceReminderFired", {
      detail: { title, body, id: reminder.id },
    })
  );

  if ("Notification" in window && Notification.permission === "granted") {
    new Notification(title, { body, tag: reminder.id });
  }

  markReminderNotified(reminder.id);
  window.dispatchEvent(new CustomEvent("voiceReminderUpdated"));
}

export function checkDueReminders() {
  const due = getPendingReminders();
  due.forEach(fireNotification);
  return due.length;
}

function scheduleTimeout(reminder) {
  if (timeouts.has(reminder.id)) return;
  const ms = new Date(reminder.remind_at).getTime() - Date.now();
  if (ms <= 0) return;
  if (ms > 2147483647) return;

  const id = window.setTimeout(() => {
    timeouts.delete(reminder.id);
    const pending = getPendingReminders();
    const hit = pending.find((r) => r.id === reminder.id);
    if (hit) fireNotification(hit);
  }, ms);
  timeouts.set(reminder.id, id);
}

export function resyncReminderTimers(reminders) {
  timeouts.forEach((id) => clearTimeout(id));
  timeouts.clear();
  reminders
    .filter((r) => !r.notified)
    .forEach(scheduleTimeout);
}

export function startReminderWatcher() {
  if (timerId) return;
  checkDueReminders();
  timerId = window.setInterval(checkDueReminders, 15000);
}

export function stopReminderWatcher() {
  if (timerId) {
    clearInterval(timerId);
    timerId = null;
  }
  timeouts.forEach((id) => clearTimeout(id));
  timeouts.clear();
}
